"use strict";
/**
 * 判断当前系统
 *
 * ### Example
 * ```
 * const system = getSystem();
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSystem = void 0;
function getSystem() {
    // 根据window是否存在判断是webview类容器还是node服务器
    if (typeof window === 'undefined') {
        return 'node';
    }
    var ua = navigator.userAgent.toLowerCase();
    if (/android/.test(ua))
        return 'android';
    if (/ios|iphone|ipod|ipad/.test(ua))
        return 'ios';
    if (/macintosh/.test(ua))
        return 'mac';
    if (/windows/.test(ua))
        return 'windows';
    return 'unknown';
}
exports.getSystem = getSystem;
